module.exports = __webpack_public_path__ + "static/media/05fa-prime.38d046dd.jpg";